import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import Img from "gatsby-image"
import { device } from '../../utils/breakpoints';

const LogoImg = styled(Img)`
    width: 180px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    margin: 0 auto;
    @media ${device.md}{
      margin: inherit;
    }
`;


const LogoImage = () => {
    const { logo } = useStaticQuery(graphql`
        query{
            logo: file(relativePath: { eq:"logo.png"}){
                sharp: childImageSharp {
                    fluid(maxWidth: 300, quality: 70) {
                    ...GatsbyImageSharpFluid
                    ...GatsbyImageSharpFluidLimitPresentationSize
                    }
                }
            }
        }
    `);
    return (
        <LogoImg fluid={logo.sharp.fluid} />
    );
}

export default LogoImage;